var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSenecCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5537 17.2744C16.4357 17.2514 16.3168 17.2309 16.1969 17.2131C16.1256 17.2025 16.054 17.1928 15.982 17.1841C15.6605 17.1451 15.3328 17.125 15 17.125C11.0545 17.125 7.78166 19.9577 7.12167 23.6748C7.02512 24.2186 6.50603 24.5812 5.96225 24.4846C5.41847 24.3881 5.05592 23.869 5.15247 23.3252C5.98076 18.6601 10.0779 15.125 15 15.125C15.3203 15.125 15.6373 15.14 15.9503 15.1694C17.1146 10.4744 21.3792 7 26.4545 7C32.4227 7 37.2727 11.8064 37.2727 17.75C37.2727 18.0974 37.2561 18.4413 37.2236 18.7807C40.5728 19.8629 43 22.9894 43 26.6875C43 31.2849 39.2489 35 34.6364 35H29C28.4477 35 28 34.5523 28 34C28 33.4477 28.4477 33 29 33H34.6364C38.1575 33 41 30.1672 41 26.6875C41 23.6405 38.8206 21.0888 35.9132 20.5019L34.9489 20.3072L35.1277 19.3399C35.2229 18.825 35.2727 18.2937 35.2727 17.75C35.2727 12.9241 31.3313 9 26.4545 9C22.3445 9 18.8966 11.7888 17.9161 15.5544C18.697 15.7907 19.4377 16.1193 20.125 16.5277C20.5538 16.7825 20.9617 17.0682 21.3456 17.3817C21.7734 17.7311 21.8369 18.3611 21.4876 18.7888C21.1382 19.2166 20.5082 19.2801 20.0805 18.9308C19.7731 18.6797 19.4465 18.451 19.1034 18.2471C18.3292 17.7871 17.4699 17.4532 16.5537 17.2744Z",
    fill: "#000099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 34C5 33.4477 5.44772 33 6 33H23C23.5523 33 24 33.4477 24 34C24 34.5523 23.5523 35 23 35H6C5.44772 35 5 34.5523 5 34Z",
    fill: "#000099"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 39C5 38.4477 5.44772 38 6 38H23C23.5523 38 24 38.4477 24 39C24 39.5523 23.5523 40 23 40H6C5.44772 40 5 39.5523 5 39Z",
    fill: "#000099"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 29C5 28.4477 5.44772 28 6 28H23C23.5523 28 24 28.4477 24 29C24 29.5523 23.5523 30 23 30H6C5.44772 30 5 29.5523 5 29Z",
    fill: "#000099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenecCloudIcon);
export default __webpack_public_path__ + "static/media/SENEC_cloud_icon.c119edef0eedcd589d83153136d1aabb.svg";
export { ForwardRef as ReactComponent };